import { useTranslation } from 'react-i18next'

import { Box, Stack, SxProps, Theme, Typography } from '@mui/material'

import responsiveHook from '@hooks/useResponsive'

import { TLGTypography } from '@components/TLGTypography'

import { scaleUpTransition } from '@utils/styles'

import {
  bulletPointsContainerSx,
  communicateSeamlesslyWithProspectiveTechnologyPartnersLeftSideContentSx,
  communicateSeamlesslyWithProspectiveTechnologyPartnersLeftSideWrapperSx,
  communicateSeamlesslyWithProspectiveTechnologyPartnersRightSideImageSx,
  communicateSeamlesslyWithProspectiveTechnologyPartnersRightSideWrapperSx,
  containerSx,
  contentGridSx,
  titleSx,
} from './styles'

import { BulletPoints } from '../BulletPoints'

const Content2Section = () => {
  const { t } = useTranslation()

  const { ifDesktop } = responsiveHook.useResponsive()

  return (
    <Box data-testid="features-content-2-section" sx={containerSx}>
      <Box
        display="grid"
        gridTemplateColumns="repeat(12, 1fr)"
        sx={contentGridSx}
      >
        <Box
          gridColumn={{ xs: 'span 12', lg: 'span 6' }}
          sx={
            communicateSeamlesslyWithProspectiveTechnologyPartnersRightSideWrapperSx
          }
        >
          <Box
            alt={t('Tech Customer Conversations page screenshot')}
            loading="lazy"
            component="img"
            src="/images/it-customer-conversations-page.webp"
            sx={
              {
                ...communicateSeamlesslyWithProspectiveTechnologyPartnersRightSideImageSx,
                ...ifDesktop(scaleUpTransition),
              } as SxProps<Theme>
            }
          />
        </Box>

        <Box
          gridColumn={{ xs: 'span 12', lg: 'span 6' }}
          sx={
            communicateSeamlesslyWithProspectiveTechnologyPartnersLeftSideWrapperSx
          }
        >
          <Stack
            sx={
              communicateSeamlesslyWithProspectiveTechnologyPartnersLeftSideContentSx
            }
          >
            <TLGTypography
              responsiveVariant={{ xs: 'h5', md: 'h4' }}
              sx={titleSx}
            >
              {t('Communicate seamlessly with prospective technology partners')}
            </TLGTypography>
            <Typography variant="body1">
              {t(
                'Say goodbye to endless email threads and missed phone calls, and connect and collaborate directly with prospective partners using our integrated messaging. '
              )}
            </Typography>

            <BulletPoints
              list={[
                t(
                  'Experience prompt and timely communication with technology partners, enabling you to address questions, clarify requirements, and gather information without delays, expediting the process.'
                ),
                t(
                  'By providing a direct channel of communication, our platform eliminates intermediaries and allows for transparent, direct interactions.'
                ),
                t(
                  'Our streamlined communication capabilities enhance collaboration, allowing you to exchange ideas, share feedback, and coordinate effectively with technology partners.'
                ),
              ]}
              containerSx={bulletPointsContainerSx}
            />
          </Stack>
        </Box>
      </Box>
    </Box>
  )
}

export { Content2Section }
